import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { FormattedMessage } from "@learningblocks/shared-components/lib/FormattedMessage";

import className from "./style.module.scss";

export function NotebookEntity(props) {
  const intl = useIntl();
  const [page] = useState(0);
  const [imageUrl, setImageUrl] = useState(null);
  const leftPage = props.data.props.notebook[page];
  const rightPage = props.data.props.notebook[page + 1];

  const baseUrl =
    window.CONTENT_BASE_URL ||
    window.location.origin + window.location.pathname;

  useEffect(() => {
    if (props.data.props.src) {
      loadImage(props.data.props.src, intl.locale)
        .then(({ imageUrl }) => {
          setImageUrl(imageUrl);
        })
        .catch((err) => {
          setImageUrl(null);
          console.error(err.message);
        });
    }
  }, [props.data.props.src, intl.locale]);

  const loadImage = (src, lng) => {
    return new Promise((resolve, reject) => {
      const tryLoadImage = (language) => {
        const image = new Image();
        const imageUrl = src.includes(window.location.origin)
          ? src
          : `${baseUrl}locales/${language}/images/${src}`;
        image.src = imageUrl;
        image.onload = () => resolve({ imageUrl });
        image.onerror = () => {
          if (language !== "en") {
            tryLoadImage("en");
          } else {
            reject(new Error(`Failed to load image from ${imageUrl}`));
          }
        };
      };

      tryLoadImage(lng);
    });
  };

  return (
    <div
      className={className.entityContainer}
      role="presentation"
      style={{
        overflow: !props.allowOverflow ? "hidden" : null,
      }}
    >
      <div
        style={{
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        className={className.notebookEntityContainer}
        role="presentation"
      >
        <div className={className.notebookEntityWrapper} role="presentation">
          <div className={className.notebookEntityhalf} role="presentation">
            <p
              className={`${className.normalTextFontSize} ${className.uppercaseText}`}
            >
              <FormattedMessage
                string={"title"}
                allowAdditionalTags={[""]}
                description=""
              />
            </p>
            <h3 className={className.headingTextFontSize}>
              <FormattedMessage
                string={leftPage.title}
                allowAdditionalTags={[""]}
                description=""
              />
            </h3>
            {leftPage.tables.map((table, index) => (
              <div className={className.tableContainer} role="presentation">
                <table
                  key={index}
                  cellPadding={0}
                  cellSpacing={0}
                  className={className.notebookTable}
                >
                  <caption className={className.normalTextFontSize}>
                    <FormattedMessage
                      string={table.caption}
                      allowAdditionalTags={[""]}
                      description=""
                    />
                  </caption>
                  <thead>
                    <tr>
                      {table.headings.map((heading) => (
                        <th className={className.normalTextFontSize}>
                          <FormattedMessage
                            string={heading}
                            allowAdditionalTags={[""]}
                            description=""
                          />
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {table.rows.map((row) => (
                      <tr>
                        {row.map((rowData, i) =>
                          i === 0 ? (
                            <th
                              className={className.normalTextFontSize}
                              key={i}
                            >
                              <FormattedMessage
                                string={rowData}
                                allowAdditionalTags={[""]}
                                description=""
                              />
                            </th>
                          ) : (
                            <td
                              className={className.normalTextFontSize}
                              key={i}
                            >
                              <FormattedMessage
                                string={rowData}
                                allowAdditionalTags={[""]}
                                description=""
                              />
                            </td>
                          )
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
            <p
              className={`${className.notebookPageNumber} ${className.normalTextFontSize}`}
            >
              {leftPage.page}
            </p>
          </div>
          <div
            className={`${className.notebookEntityhalf} ${className.notebookEntityhalfRight}`}
            role="presentation"
          >
            <div className={className.pageContainer} role="presentation">
              <p
                className={`${className.normalTextFontSize} ${className.uppercaseText}`}
              >
                <FormattedMessage
                  string={"title"}
                  allowAdditionalTags={[""]}
                  description=""
                />
              </p>
              <h3 className={className.headingTextFontSize}>
                <FormattedMessage
                  string={rightPage.title}
                  allowAdditionalTags={[""]}
                  description=""
                />
              </h3>

              {rightPage.tables.map((table, index) => (
                <div className={className.tableContainer} role="presentation">
                  <table
                    key={index}
                    cellPadding={0}
                    cellSpacing={0}
                    className={className.notebookTable}
                  >
                    <caption className={className.normalTextFontSize}>
                      <FormattedMessage
                        string={table.caption}
                        allowAdditionalTags={[""]}
                        description=""
                      />
                    </caption>
                    <thead>
                      <tr>
                        {table.headings.map((heading) => (
                          <th className={className.normalTextFontSize}>
                            <FormattedMessage
                              string={heading}
                              allowAdditionalTags={[""]}
                              description=""
                            />
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {table.rows.map((row) => (
                        <tr>
                          {row.map((rowData, i) =>
                            i === 0 ? (
                              <th
                                className={className.normalTextFontSize}
                                key={i}
                              >
                                <FormattedMessage
                                  string={rowData}
                                  allowAdditionalTags={[""]}
                                  description=""
                                />
                              </th>
                            ) : (
                              <td
                                className={className.normalTextFontSize}
                                key={i}
                              >
                                <FormattedMessage
                                  string={rowData}
                                  allowAdditionalTags={[""]}
                                  description=""
                                />
                              </td>
                            )
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))}
              <p
                className={`${className.notebookPageNumber} ${className.normalTextFontSize}`}
              >
                {rightPage.page}
              </p>
            </div>
          </div>
        </div>
        {props.data.props.notebook.length > 2 && (
          <>
            <svg
              className={className.arrowLeft}
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="40" cy="40" r="39.5" stroke="white" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M49.0728 57.5606C47.6585 59.2577 45.1363 59.487 43.4392 58.0728L25.4392 43.0728C24.5272 42.3128 23.9999 41.187 23.9999 39.9999C23.9999 38.8128 24.5272 37.687 25.4392 36.927L43.4392 21.927C45.1363 20.5128 47.6585 20.7421 49.0728 22.4392C50.487 24.1363 50.2577 26.6585 48.5606 28.0728L34.2481 39.9999L48.5606 51.927C50.2577 53.3413 50.487 55.8635 49.0728 57.5606Z"
                fill="white"
              />
            </svg>

            <svg
              className={className.arrowRight}
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="40" cy="40" r="39.5" stroke="white" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.9272 22.4394C32.3415 20.7423 34.8637 20.513 36.5608 21.9272L54.5608 36.9272C55.4728 37.6872 56.0001 38.813 56.0001 40.0001C56.0001 41.1872 55.4728 42.313 54.5608 43.073L36.5608 58.073C34.8637 59.4872 32.3415 59.2579 30.9272 57.5608C29.513 55.8637 29.7423 53.3415 31.4394 51.9272L45.7519 40.0001L31.4394 28.073C29.7423 26.6587 29.513 24.1365 30.9272 22.4394Z"
                fill="white"
              />
            </svg>
          </>
        )}
      </div>
    </div>
  );
}

NotebookEntity.propTypes = {
  data: PropTypes.shape({
    props: PropTypes.shape({
      src: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  allowOverflow: PropTypes.bool.isRequired,
};
